import NavComponent from './nav';
import MobileMenuComponent from './mobile-menu';

export default class HeaderComponent {
  static CLASSES = {
    HEADER: 'header',
    HEADER_VISIBLE: 'header--visible',
    HEADER_INITIALIZING: 'header--initializing',
    HAMBURGER: 'header__hamburger',
    HEADER_FIXED: 'header--fixed',
    HEADER_DECORIZED: 'header--decor',
    HEADER_HIDDEN: 'header--hidden'
  };

  static SELECTORS = {
    DECOR: '.about-new, .park-new, .legacy'
  };

  static init($header) {
    if (!$header || $header.headerComponent) {
      return;
    }

    $header.headerComponent = new HeaderComponent($header);
  }

  static initAll() {
    document.querySelectorAll(`.${HeaderComponent.CLASSES.HEADER}`).forEach(($header) => {
      HeaderComponent.init($header);
    });
  }

  constructor($header) {
    this.isDecorized = document.querySelector(HeaderComponent.SELECTORS.DECOR) ? true : false;
    this.$header = $header;
    this.$hamburger = $header.querySelector(`.${HeaderComponent.CLASSES.HAMBURGER}`);
    this.mobileMenu = document.querySelector(
      `.${MobileMenuComponent.CLASSES.MOBILE_MENU}`
    ).mobileMenuComponent;

    this.onResizeWindow = this.onResizeWindow.bind(this);
    this.onScrollWindow = this.onScrollWindow.bind(this);
    this.onClickHamburger = this.onClickHamburger.bind(this);

    this.init();
  }

  init() {
    if (!this.isFixed()) {
      this.makeFixedClone().then(() => {
        this.updateFixedCloneVisibility();
        window.addEventListener('resize', this.onResizeWindow);
        window.addEventListener('scroll', this.onScrollWindow);

        if (this.isDecorized) {
          this.$header.classList.add(HeaderComponent.CLASSES.HEADER_HIDDEN);
          this.$headerFixedClone.classList.add(HeaderComponent.CLASSES.HEADER_DECORIZED);
        }
      });
    }

    this.$hamburger.addEventListener('click', this.onClickHamburger);
  }

  destroy() {
    if (!this.isFixed()) {
      window.removeEventListener('resize', this.onResizeWindow);
      window.removeEventListener('scroll', this.onScrollWindow);
    }

    this.$hamburger.removeEventListener('click', this.onClickHamburger);

    this.mobileMenu = null;
    this.$header.headerComponent = null;
  }

  onResizeWindow() {
    this.updateFixedCloneVisibility();
  }

  onScrollWindow() {
    this.updateFixedCloneVisibility();
  }

  onClickHamburger() {
    this.mobileMenu.open();
  }

  isFixed() {
    return this.$header.classList.contains(HeaderComponent.CLASSES.HEADER_FIXED);
  }

  updateFixedCloneVisibility() {
    if (!this.$headerFixedClone) {
      return;
    }

    const scrollValue = this.isDecorized ? 0 : 300;

    if (window.pageYOffset >= scrollValue) {
      this.$headerFixedClone.classList.add(HeaderComponent.CLASSES.HEADER_VISIBLE);
      this.$headerFixedClone.setAttribute('aria-hidden', 'false');
    } else {
      this.$headerFixedClone.classList.remove(HeaderComponent.CLASSES.HEADER_VISIBLE);
      this.$headerFixedClone.setAttribute('aria-hidden', 'true');
    }
  }

  makeFixedClone() {
    return new Promise((resolve) => {
      this.$headerFixedClone = this.$header.cloneNode(true);
      this.$headerFixedClone.classList.add(HeaderComponent.CLASSES.HEADER_INITIALIZING);
      this.$headerFixedClone.classList.add(HeaderComponent.CLASSES.HEADER_FIXED);
      this.$headerFixedClone.classList.add(HeaderComponent.CLASSES.HEADER_VISIBLE);
      this.$header.parentElement.appendChild(this.$headerFixedClone);

      NavComponent.initAll();
      HeaderComponent.init(this.$headerFixedClone);

      requestAnimationFrame(() => {
        this.$headerFixedClone.classList.remove(HeaderComponent.CLASSES.HEADER_VISIBLE);
        this.$headerFixedClone.classList.remove(HeaderComponent.CLASSES.HEADER_INITIALIZING);

        resolve();
      });
    });
  }
}
